import { Banner } from '@tackle-io/platform-ui';
import { AssignmentIcon } from 'packages/cosell/assets';
import FormSectionCard from '../components/FormSectionCard';
import { FormSectionConfig } from '../constants';
import useToggleState from 'hooks/useToggleState';
import { AddTeamMemberFormDrawer } from './AddTeamMemberDrawer/AddTeamMemberDrawer';
import { useFieldArray } from 'react-hook-form';
import type { TeamType } from './sectionSchema';
import { useReferralFormContext } from '../ReferralFormContext';
import MemberListItem from './MemberListItem';
import { useCallback } from 'react';
import { FieldEnum } from './sectionSchema';

const ZeroStateContent = ({
  hasRequiredError,
}: {
  hasRequiredError?: boolean;
}) => (
  <>
    <Banner
      borderPosition="top"
      isCollapsible
      title="At least one team member is required to create a referral."
      type={!!hasRequiredError ? 'danger' : 'info'}
    />

    <FormSectionCard.BlockMessage>
      You haven't added a team member yet.
    </FormSectionCard.BlockMessage>
  </>
);

type MemberInput = TeamType[number];
export const TeamMembersFormSection = () => {
  const [drawerIsOpen, toggleDrawer] = useToggleState(false);
  const { control, formState } = useReferralFormContext();
  const { fields, append, remove } = useFieldArray<MemberInput>({
    control,
    name: FieldEnum['team'],
  });

  const handleAddMember = useCallback(
    (member: TeamType[number]) => {
      append(member);
    },
    [append],
  );

  const removeSolution = useCallback(
    (index: number) => {
      remove(index);
    },
    [remove],
  );

  /** @ts-expect-error -- message does exist on team */
  const hasRequiredValidationError = formState.errors?.team?.message;

  return (
    <>
      <FormSectionCard
        title={FormSectionConfig.teamMembers.title}
        subtitle={FormSectionConfig.teamMembers.subtitle}
        icon={<AssignmentIcon />}
        data-id={FormSectionConfig.teamMembers.dataId}
        sectionId={FormSectionConfig.teamMembers.id}
      >
        {!!fields?.length ? (
          <div>
            {fields.map((member, index) => (
              <MemberListItem
                key={member.id}
                fieldName={`${FieldEnum['team']}[${index}]`}
                member={member}
                onDelete={() => removeSolution(index)}
              />
            ))}
          </div>
        ) : (
          <ZeroStateContent hasRequiredError={hasRequiredValidationError} />
        )}

        <FormSectionCard.AddButton
          disabled={fields.length > 4}
          onClick={toggleDrawer}
        >
          Add team member
        </FormSectionCard.AddButton>
      </FormSectionCard>
      <AddTeamMemberFormDrawer
        onAddMember={handleAddMember}
        open={drawerIsOpen}
        onClose={toggleDrawer}
      />
    </>
  );
};

export default TeamMembersFormSection;
